import React from 'react';
import { CheckCircle, Target, Users, Award } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Target,
      title: 'Sélection rigoureuse',
      description: 'Nous analysons chaque plateforme selon des critères stricts : sécurité, rapidité des paiements, variété des marchés et qualité du service client.',
    },
    {
      icon: Users,
      title: 'Expertise indépendante',
      description: 'Notre équipe teste personnellement chaque site pour vous offrir des avis authentiques et objectifs, sans influence des opérateurs.',
    },
    {
      icon: Award,
      title: 'Comparaison transparente',
      description: 'Mise en avant des avantages et inconvénients de chaque plateforme pour vous aider à faire le choix le plus adapté à vos besoins.',
    },
    {
      icon: CheckCircle,
      title: 'Mise à jour constante',
      description: 'Nous suivons l\'évolution des offres et des conditions pour vous garantir des informations toujours à jour et pertinentes.',
    },
  ];

  return (
    <section id="a-propos" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" itemProp="headline">
              Pourquoi choisir ParisPari Hub ?
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" itemProp="description">
              Nous sommes votre partenaire de confiance pour naviguer dans l'univers des paris en ligne en France. 
              Notre mission : vous faire gagner du temps et de l'argent en vous orientant vers les meilleures opportunités.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Avec des années d'expérience dans l'analyse des plateformes de paris, nous comprenons ce qui compte vraiment 
              pour les joueurs : des bonus attractifs, des retraits rapides, une interface claire et un support réactif.
            </p>
            <div className="flex items-center space-x-4">
              <div className="flex -space-x-2">
                <div className="w-12 h-12 rounded-full bg-primary-red border-2 border-white"></div>
                <div className="w-12 h-12 rounded-full bg-primary-red-dark border-2 border-white"></div>
                <div className="w-12 h-12 rounded-full bg-primary-red-light border-2 border-white"></div>
              </div>
              <div>
                <p className="font-semibold text-gray-900">Plus de 50 000 utilisateurs</p>
                <p className="text-sm text-gray-600">nous font confiance chaque mois</p>
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-100"
                >
                  <div className="bg-primary-red/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="text-primary-red" size={24} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

